import { render, staticRenderFns } from "./lawyerList.vue?vue&type=template&id=b247bd60&scoped=true&"
import script from "./lawyerList.vue?vue&type=script&lang=ts&"
export * from "./lawyerList.vue?vue&type=script&lang=ts&"
import style0 from "./lawyerList.vue?vue&type=style&index=0&id=b247bd60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b247bd60",
  null
  
)

export default component.exports